import { h } from 'preact';
import React, { Component } from 'react';

import { PMButtonSettings } from './PMButtonSettings';
import './PMButton.css';
import { makeText, languageUsed } from '../../util';
import { actionTypes } from '../../constants';

export class PMButton extends Component {
  makeChoice = () => {
    const { language, component: { settings } } = this.props;
    const choice = settings.action_type;
    if (choice) {
      this.props.makeChoice(actionTypes[choice], languageUsed(language, new PMButtonSettings(settings), 'text'));
    };
  }

  render() {
    const settings = new PMButtonSettings(this.props.component.settings);
    const { language, dev } = this.props;
    const styles = {
      ...settings.padding,
      ...settings.margin,
      ...settings.border,
      ...settings.font
    };

    /* WIDTH & HEIGHT */
    const { paddingLeft, paddingRight } = settings.padding;
    const { marginLeft, marginRight } = settings.margin;

    styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
    if (settings.width.type === '%') {
      styles.width = `calc(${settings.width.value}% - ${(paddingLeft + paddingRight + marginLeft + marginRight)}px`;
    };

    styles.background = settings.background;

    /* DEV MODE ONLY */
    let devActions = {}, selected = false, path = JSON.stringify(this.props.path);
    if (dev) {
      devActions = { ...dev.hover };
      selected = dev.current === path;
    }

    const className = 'message-component message-button no-children focusable' + this.props.className;
    const btnText = makeText(dev, settings, 'text', language);
    return (
      <button
        aria-label={btnText}
        tabindex={settings.startFocus ? 1 : 0}
        title={btnText}
        onClick={this.makeChoice}
        onKeyDown={(e) => e.keyCode === 13 && this.makeChoice()}
        className={selected ? className + ' on-active' : className}
        path={path}
        style={styles}
        {...devActions}
      >
        {btnText}
      </button>
    );
  }
}